import { Route, Switch } from "react-router-dom";

import AnalyticsByChannelPage from "@faire/prototype-playground/workspace/jtu/analytics-channels";

export function JiaTuRoutes() {
  return (
    <Switch>
      <Route path="/jtu/analytics-channels" component={AnalyticsByChannelPage} />
    </Switch>
  );
}

export const slug = "jtu";
